const beep = () => {
    const ctx = new window.AudioContext();
    const oscillator = ctx.createOscillator();
    const gainNode = ctx.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(ctx.destination);

    oscillator.type = 'square';            // Son plus "agressif"
    oscillator.frequency.value = 800;      // Fréquence
    gainNode.gain.value = 0.2;

    oscillator.start();
    oscillator.stop(ctx.currentTime + 0.08); // Durée 80ms
};

export const longBeep = () => {
    const ctx = new window.AudioContext();
    const oscillator = ctx.createOscillator();
    const gainNode = ctx.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(ctx.destination);

    oscillator.type = 'square';            // Son plus "agressif"
    oscillator.frequency.value = 500;      // Fréquence 
    gainNode.gain.value = 0.2;

    oscillator.start();
    oscillator.stop(ctx.currentTime + 0.5); // Durée 500ms
};

export default beep;